import * as React from 'react'

import { useIntl } from 'react-intl'
import { useCMSPageField } from '@/cms/fields'
import { HeadingLabel } from '@/scopes/products/pages/components/HeadingLabel'
import DestinationMap from './DestinationMap'
import DestinationMoreInfo from './DestinationMoreInfo'
import styles from './DestinationSection.module.css'

export default function DestinationSection() {
  const intl = useIntl()
  const { lat, lng } = useCMSPageField('PDP.coordinates')

  return (
    <section>
      <HeadingLabel text={intl.formatMessage({ id: 'accommodation_page_destination_title' })} />
      <div className={styles.mainContent}>
        <DestinationMap className={styles.map} lat={lat} lng={lng} />
        <DestinationMoreInfo />
      </div>
    </section>
  )
}
